/**
 * @generated SignedSource<<d6dce351f93a1d75ea2812789345b495>>
 * @relayHash 3ff957356a222a0403de8acaa865ca65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7162393035fd06cf5e129612e4945c0ef12446f238f667ff837e7d2e10367f76

import type { ConcreteRequest } from 'relay-runtime';
export type PageSwitcherWithQueryQuery$variables = {
  cloudId: string;
};
export type PageSwitcherWithQueryQuery$data = {
  readonly jira: {
    readonly hasJsmAdminAccess: boolean | null;
  } | null;
};
export type PageSwitcherWithQueryQuery = {
  response: PageSwitcherWithQueryQuery$data;
  variables: PageSwitcherWithQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "concreteType": "JiraQuery",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "kind": "ScalarField",
        "name": "hasJsmAdminAccess"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageSwitcherWithQueryQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageSwitcherWithQueryQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "7162393035fd06cf5e129612e4945c0ef12446f238f667ff837e7d2e10367f76",
    "metadata": {},
    "name": "PageSwitcherWithQueryQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8f09c3e6bfdfcef08a6f9f4abf500de6";

export default node;
